import { defineComponent, Transition } from "vue";
import common from "../core/core";
import { mainModelService } from "@/services/main.model.service";
import { SimpleTimer } from "@/utilities";
import anime from "animejs";

export default defineComponent({
  name: "CallBubble",
  data() {
    return {
      id: "call-bubble",
      isCustomer: false,
      loaded: false,
      dialog: false,
      notificationIndicator: false,
      isHovered: false,
      isSuccess: false,
      isFailure: false,
      mainModelService,
      tariffsService: this.$store.direct.getters.tariffsService,
      simpleTimer: null,
      requiredSecondsElapsed: 30, //default: 30
      requiredSecondsIncrement: 60, //default: 60
      animationTimeline: null,
    };
  },
  components: {
    Transition,
  },
  methods: {
    toggleDialog(): void {
      this.notificationIndicator = false;
      this.dialog = !this.dialog;
      this.simpleTimer.setSecondsElapsed(0);
      if (this.dialog) {
        const event = "website_interaction";
        const payload = {
          element: "call-bubble",
          status: "opened",
        };
        this.$store.direct.getters.exponeaService.track(event, payload);
      }
    },
    enoughTimeElapsed(): boolean {
      if (this.simpleTimer == null) {
        return false;
      }

      return (
        this.simpleTimer.getSecondsElapsed() > 0 &&
        this.simpleTimer.getSecondsElapsed() % this.requiredSecondsElapsed == 0
      ); //30, 90, 150, 210, 270, 330, ...
    },
    resetSecondsElapsed(): void {
      if (this.enoughTimeElapsed()) {
        this.simpleTimer.setSecondsElapsed(0);
        this.requiredSecondsElapsed += this.requiredSecondsIncrement; //60

        if (!this.dialog && !this.isHovered) {
          this.animationTimeline.restart();
        }
      }
    },
    subscribeToPhoneInput(): void {
      this.AppService.phoneBlockSubject.subscribe(async (data) => {
        const containerTariffsPhone = document.querySelector(".call-bubble-component #phone-block-" + this.id);

        if (containerTariffsPhone) {
          const tariff = this.$store.direct.getters.tariffsService.getTariff();
          const address = this.$store.direct.getters.addressService.address;
          const hasCoverage = await this.$store.direct.getters.coverageService.getHasCoverage();
          const hasPlannedCoverage = await this.$store.direct.getters.coverageService.getHasPlannedCoverage();
          const token = await this.$store.direct.getters.recaptchaService.getToken("order");
          const phoneNumber = data.code + data.number;
          // Prepare the request
          const reqBuilder = this.$store.direct.getters.createWebOrderRequestBuilderFactory.create();
          reqBuilder.setAddress(address);
          reqBuilder.setPhone(phoneNumber);
          reqBuilder.setTariff(tariff);
          reqBuilder.setHasCoverage(hasCoverage);
          reqBuilder.setHasPlannedCoverage(hasPlannedCoverage);
          reqBuilder.setRecaptcha(token);

          if (this.tariffsService.isCompanyTariff) {
            reqBuilder.setCustomerType("b2b");
          }

          let webApiResponse = null;
          try {
            webApiResponse = await this.$store.direct.getters.webApiService.createWebOrder(
              await reqBuilder.getRequest()
            );
            this.phoneBlockLoading = false;
            this.isSuccess = true;
          } catch (e) {
            this.phoneBlockLoading = false;
            this.isFailure = true;
          }

          const event = "phone_submit_bubble";
          const payload = {
            web_order_uuid: webApiResponse?.uuid ?? null,
            url: window.location.pathname,
            city: address?.mesto,
            has_coverage: hasCoverage,
            phone_number: phoneNumber,
          };

          await this.$store.direct.getters.exponeaService.trackOncePerSession(event, payload);

          await this.$store.direct.getters.gtmService.trackOncePerSession(event, payload);
        }
      });
    },
  },
  async mounted() {
    const customerResponse = await this.$store.direct.getters.customerService.getIsCustomer();

    await this.$store.direct.getters.recaptchaService.init();

    this.isCustomer = customerResponse.isCustomer;

    this.subscribeToPhoneInput();

    this.loaded = true;

    this.animationTimeline = anime.timeline({
      targets: ".call-bubble-component .call-button",
      duration: 100,
      autoplay: false,
    });

    this.animationTimeline.finished.then(() => {
      this.notificationIndicator = true;
    });

    this.animationTimeline
      .add({ translateX: 7 })
      .add({ translateX: -7 })
      .add({ translateX: 7 })
      .add({ translateX: -7 })
      .add({ translateX: 7 })
      .add({ translateX: -7 })
      .add({ translateX: 7 })
      .add({ translateX: 0 });

    this.simpleTimer = new SimpleTimer(this.resetSecondsElapsed);
  },
  mixins: [common],
});
